import { render } from "./TTMWellClusterForm.vue?vue&type=template&id=2b7fe8a8"
import script from "./TTMWellClusterForm.vue?vue&type=script&setup=true&lang=js"
export * from "./TTMWellClusterForm.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/pages/scada/forms/TTMWellClusterForm.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2b7fe8a8"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2b7fe8a8', __exports__)) {
    console.log('reload')
    api.reload('2b7fe8a8', __exports__)
  }
  
  module.hot.accept("./TTMWellClusterForm.vue?vue&type=template&id=2b7fe8a8", () => {
    console.log('re-render')
    api.rerender('2b7fe8a8', render)
  })

}


export default __exports__